import axios from 'axios';

export class KaskoService {
  constructor() {
    this.baseUrl = KaskoService.getApiUrl();
  };

  static getApiUrl = () => {
    if (window.location.hostname === 'localhost') {
      return 'https://test.polis.ua/kasko/api/';
    }
    return '/kasko/api/';
  };

  // получить список марок авто
  getAutoMarks = async () => {
    const url = 'auto/marks';

    return await axios.get(`${this.baseUrl}${url}`);
  };

  // получить список моделей авто
  getAutoModels = async (markId) => {
    const url = `auto/models?markId=${markId}`;

    return await axios.get(`${this.baseUrl}${url}`);
  };

  // получить список типов топлива
  getAutoFuelTypes = async () => {
    const url = 'auto/fuel';

    return await axios.get(`${this.baseUrl}${url}`);
  };

  // получить список типов коробки передач
  getAutoTransmissionsTypes = async () => {
    const url = 'auto/gearBoxes';

    return await axios.get(`${this.baseUrl}${url}`);
  };

  // получить данные авто по гос.номеру
  getAutoDataByNumber = async (autoNumber) => {
    const url = `auto/info?carNumber=${autoNumber}`;

    return await axios.get(`${this.baseUrl}${url}`);
  };

  // получить список областей
  getRegions = async () => {
    const url = 'auto/states';

    return await axios.get(`${this.baseUrl}${url}`);
  };

  // получить список городов
  getCities = async (cityId) => {
    const url = `auto/cities?stateId=${cityId}`;

    return await axios.get(`${this.baseUrl}${url}`);
  };

  // получить офферы компаний
  getOffers = async (userDeclaration) => {
    const url = 'auto/offers';

    return await axios.post(`${this.baseUrl}${url}`, userDeclaration);
  };

  // получить цену на авто
  getCarPrice = async (options) => {
    const url = 'auto/calcPrice';

    return await axios.post(`${this.baseUrl}${url}`, options);
  };

  // создать ордер
  createOrder = async (options) => {
    const url = 'auto/order';

    return await axios.post(`${this.baseUrl}${url}`, options);
  }

  // отправить otp
  sendOtp = async (phoneData) => {
    const url = "auto/sendOtp";
    const userPhone = {
      "phone": `${phoneData}`
    };

    return await axios.post(`${this.baseUrl}${url}`, userPhone);
  }

  // отправить повторно otp
  reSendOtp = async (phoneData) => {
    const url = "auto/reSendOtp";
    const userPhone = {
      "phone": `${phoneData}`
    };

    return await axios.post(`${this.baseUrl}${url}`, userPhone);
  }

  initCookie = async (admitad_uid) => {
    const url = `postback?token=${admitad_uid}`;

    return await axios.get(`${this.baseUrl}${url}`);
  };
}
